import { openDB } from 'idb';

export async function syncDeviceInfo() {
  const localDeviceId = localStorage.getItem('device_id');
  const localStoreId = localStorage.getItem('store_id');

  const db = await openDB('FDBK', 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('devices')) {
        db.createObjectStore('devices', { keyPath: 'device_id' });
      }
    }
  });

  const tx = db.transaction('devices', 'readwrite');
  const store = tx.objectStore('devices');
  const allDevices = await store.getAll();

  const dbEntry = allDevices[0];

  // ✅ Case 1: Restore IndexedDB from localStorage if DB is empty
  if ((!dbEntry || !dbEntry.device_id) && localDeviceId) {
    await store.put({ device_id: localDeviceId, store_id: localStoreId });
    console.log('✅ IndexedDB restored from localStorage');
  }

  // ✅ Case 2: Restore localStorage from IndexedDB if localStorage is empty
  else if (!localDeviceId && dbEntry?.device_id) {
    localStorage.setItem('device_id', dbEntry.device_id);
    localStorage.setItem('store_id', dbEntry.store_id);
    console.log('✅ localStorage restored from IndexedDB');
  }

  await tx.done;
}
